
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inschrijven",
      function () {
        return require("private-next-pages/inschrijven.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inschrijven"])
      });
    }
  